import React, {FC} from 'react';
import {Panel as UafPanel} from '@components/atoms';

const Panel: FC = () => <UafPanel />;

export {Panel};
